import { Suspense, lazy } from 'react';

const PlainTextContentInner = lazy(() => import('./PlainTextContent'));

export const PlainTextContent = ({ children }: { children: string }) => (
  <Suspense fallback={children}>
    <PlainTextContentInner>{children}</PlainTextContentInner>
  </Suspense>
);
